import { SOCIAL_BUTTONS_CONF } from '../../organizedByType/config/socialButtonsConfig'
const INITIAL_STATE = {
  socialButtonsConfig: SOCIAL_BUTTONS_CONF,
}

export function configReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/store/config/config.reducers.js